module.exports = __webpack_public_path__ + "img/ABA PAY.ef081c3d.svg";